import React from "react";
import MyBox from "./MyBox";

interface MyFlexWrapBoxProps {
  children?: React.ReactNode;
  classname?:string;
  topText?:string;
}

export const MyFlexWrapBox: React.FC<MyFlexWrapBoxProps> = ({ children, classname, topText }) => {
  return (
    <MyBox topText={topText}>
      <div className={`${classname} flex flex-wrap gap-2 items-center justify-between`}>
        {children}
      </div>
    </MyBox>
  );
};


interface MyButtonProps {
  active?: boolean;
  disabled?: boolean; // ✅ NEW
  label: string;
  styles?: string;
  topText?: string;
  onClick?: () => void;
}

export const MyButton: React.FC<MyButtonProps> = ({
  active,
  disabled = false,
  styles,
  label,
  topText,
  onClick,
}) => {
  return (
    <button
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      className={`
        ${styles}
        relative whitespace-nowrap rounded-full px-5 py-2 text-sm shadow-sm transition
        ${
          disabled
            ? "bg-gray-200 text-gray-400 cursor-not-allowed dark:bg-gray-700 dark:text-gray-400"
            : active
            ? "bg-black text-white"
            : "hover:bg-gray-100 dark:border dark:text-gray-100 dark:hover:bg-gray-600"
        }
      `}
    >
      {topText && (
        <div className="absolute -mt-4.5 text-[10px] text-black/60 dark:bg-gray-200 px-1 rounded-full">
          {topText}
        </div>
      )}
      {label}
    </button>
  );
};







type SelectItem = {
  label: string;
  value: string;
};

interface MyFlexButtonsProps {
  items: SelectItem[];
  value: string;
  onChange: (value: string) => void;
}

export const MyFlexButtons: React.FC<MyFlexButtonsProps> = ({
  items = [],
  value,
  onChange,
}) => {
  return (
    <MyBox>
      <div
        className="
          flex flex-wrap gap-1
          overflow-x-auto
          whitespace-nowrap
          pb-2
        "
      >
        {items.map((item) => (
          <MyButton
            key={item.value}
            label={item.label}
            active={value === item.value}
            onClick={() => onChange(item.value)}
          />
        ))}
      </div>
    </MyBox>
  );
};

